import { gql } from '@apollo/client';

const ADD_MACHINE_TO_CUSTOMER = gql`
    mutation AddDeviceToCustomer($input: AddDeviceCustomer!) {
        addDeviceToCustomer(input: $input) {
            data {
                connection_status
                connection_type
                createdAt
                device_id
                device_name
                id
                machine_name
                operation_mode
                updatedAt
                user_id
            }
            message
            success
        }
    }
`;

export { ADD_MACHINE_TO_CUSTOMER };
